import React from 'react';
import { Box, Container, Heading, Text, VStack, SimpleGrid, Icon } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

const MotionBox = motion(Box);

const WhyUsComparison = ({ data }) => {
  return (
    <Box py={{ base: 16, md: 20 }} bg="white">
      <Container maxW="container.xl">
        <VStack spacing={12}>
          <VStack spacing={4} textAlign="center">
            <Heading size="2xl" fontWeight="900" color="brand.800">
              {data.title}
            </Heading>
            <Text fontSize="lg" color="brand.500">
              {data.subtitle}
            </Text>
          </VStack>

          {/* Mobile horizontal scroll container */}
          <Box 
            w="full" 
            overflowX="auto" 
            sx={{
              '&::-webkit-scrollbar': {
                height: '8px',
              },
              '&::-webkit-scrollbar-track': {
                background: 'brand.50',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: 'brand.300',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: 'brand.400',
              },
            }}
          >
            <Box 
              minW={{ base: '600px', md: 'full' }} // Minimum width for mobile scroll
              w="full"
            >
              <SimpleGrid 
                columns={{ base: 3, md: 3 }} 
                spacing={0} 
                w="full" 
                overflow="hidden" 
                borderRadius="2xl" 
                boxShadow="0 4px 20px rgba(0,0,0,0.08)"
              >
                {data.columns.map((column, colIndex) => (
                  <MotionBox
                    key={colIndex}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: colIndex * 0.2 }}
                  >
                    <Box
                      p={6}
                      bg={colIndex === 0 ? 'accent.green' : 'brand.50'}
                      h="full"
                      borderRight={colIndex < 2 ? { base: '1px solid', md: '1px solid' } : 'none'}
                      borderColor={colIndex === 0 ? 'whiteAlpha.300' : 'brand.200'}
                      minH="500px"
                      display="flex"
                      flexDirection="column"
                    >
                      <VStack spacing={4} align="stretch" flex="1">
                        <Heading
                          size="md"
                          color={colIndex === 0 ? 'white' : 'brand.800'}
                          textAlign="center"
                          pb={4}
                          borderBottom="2px solid"
                          borderColor={colIndex === 0 ? 'whiteAlpha.300' : 'brand.200'}
                        >
                          {column.category}
                        </Heading>
                        <Box flex="1">
                          {column.features.map((feature, index) => (
                            <Box
                              key={index}
                              display="flex"
                              alignItems="center"
                              py={3}
                              justifyContent={colIndex === 0 ? 'flex-start' : 'center'}
                              minH="50px"
                            >
                              <Icon
                                as={feature.available ? FaCheckCircle : FaTimesCircle}
                                color={
                                  colIndex === 0
                                    ? 'white'
                                    : feature.available
                                    ? 'accent.green'
                                    : 'brand.300'
                                }
                                mr={colIndex === 0 ? 3 : 0}
                                boxSize={colIndex === 0 ? 5 : 6}
                              />
                              {colIndex === 0 && (
                                <Text
                                  fontSize="sm"
                                  color={colIndex === 0 ? 'white' : 'brand.600'}
                                  fontWeight="500"
                                >
                                  {feature.name}
                                </Text>
                              )}
                            </Box>
                          ))}
                        </Box>
                      </VStack>
                    </Box>
                  </MotionBox>
                ))}
              </SimpleGrid>
            </Box>
          </Box>
        </VStack>
      </Container>
    </Box>
  );
};

export default WhyUsComparison;